<template>
  <div class="private-letter-page">
    <div class="private-letter">
      <!-- <div class="tip">
        <p>打开南方+,实时接收私信消息</p>
        <button @click="open">立即打开</button>
      </div>-->
      <div
        class="more"
        @click="refreshMore"
        v-if="moreMsg"
        :id="moreMsgAnimation"
      >
        <img src="@/assets/icon_more@3x.png" alt />
        <span>加载更多私信消息</span>
      </div>
      <div class="message-content" id="message-content" @click="handleShowImageBtn(false)">
        <div
          class="message-item-right"
          v-for="(item, index) in messageList"
          :key="index"
        >
          <div>
            <div class="right-wrap" v-if="item.sourceUuid == sourceUuid">
              <div class="time">
                <span v-if="item.fiveFlag">{{ item.messageTime }}</span>
              </div>
              <div class="right-inner">
                <div class="content">
                  <img
                    class="arrow"
                    src="@/assets/sanjiaoxing_blue@3x.png"
                    alt
                  />
                  <div v-if="item.type == 31" v-html="item.content"></div>
                  <div v-if="item.type == 32 && item.extMsgObj" class="content-img">
                    <span class="icon-fail" v-if="item.failFlag"></span>
                    <span class="icon-uploading" v-if="item.loadingFlag"></span>
                    <img :src="item.extMsgObj.imageUrl" alt="">
                  </div>
                </div>
                <div class="img">
                  <img :src="item.sourceHeadImg" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="left-wrap" v-if="item.targetUserUuid == sourceUuid">
            <div class="message-item-left">
              <div class="time">
                <span v-if="item.fiveFlag">{{ item.messageTime }}</span>
              </div>
              <div class="left-inner">
                <div class="img">
                  <img :src="item.sourceHeadImg" alt />
                </div>
                <div class="content">
                  <img
                    class="arrow"
                    src="@/assets/sanjiaoxing_white@3x.png"
                    alt
                  />
                  <div v-if="item.type == 31" v-html="item.content"></div>
                  <div v-if="item.type == 32 && item.extMsgObj" class="content-img">
                    <img :src="item.extMsgObj.imageUrl" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="redOpen" @click="open">
        <p>南方+APP内打开</p>
      </div>
      <div class="send-message">
        <div class="text-box">
            <textarea
              id="input"
              @input="handleInput"
              @click="inputCilick"
              @blur="handleBlur"
              @focus="handleFocus"
              rows="1"
              ref="textareaContent"
              placeholder="请输入想对Ta说的话..."
            ></textarea>
            <span v-if="showSendBtn" class="sendText" @click="sendMessage">发送</span>
            <span v-else class="icon-plus" @click="handleShowImageBtn(true)"></span>
        </div>
        <div class="image-box" v-if="showImageBtn">
          <div class="upload-item">
            <span class="icon-upload" @click="handleSelectFile"><i></i>照片</span>
            <!-- <input class="image-input" type="file" accept="image/*" @change="handleSelectFile" /> -->
          </div>
        </div>
      </div>
      
    </div>
    <div class="maskWrap" v-if="maskWrap">
      <div class="innerBox">
        <img @click="close" src="@/assets/icon_close_gray@3x.png" alt />
        <div class="content">
          <p class="title">私信消息已成功发送</p>
          <p class="check">私信消息可在APP「我」-「我的消息」中查看</p>
          <p class="login">注：请使用微信登录</p>
        </div>
        <div class="bottom-button">
          <div class="btn" @click="continueLetter" style="margin-left: 0.4rem">
            继续私信
          </div>
          <div class="btn red" @click="goToSee">前往查看</div>
        </div>
      </div>
    </div>
    <!-- <div class="contentTip" v-if="contentTip"></div> -->
    <nf-toast v-model="contentTip" :toastTxt="'请输入聊天内容'"></nf-toast>
    <nf-toast
      v-model="toastOptions.showTost"
      :toastTxt="toastOptions.toastTxt"
    ></nf-toast>
    <nf-loading :showLoading="showLoading" :text="loadingText"></nf-loading>
    <nf-toast v-model="showImgToast" :toastTxt="imgToastTxt"></nf-toast>
  </div>
</template>
<script>
import axios from "axios";
//日期格式
var dayjs = require("dayjs");
dayjs().format();
import config from "../../../config";
import _ from "lodash";

export default {
  name: "privateLetter",
  data() {
    return {
      pageNum: 1,
      message: "",
      messageList: [],
      messageTimeList: [], //用于五分钟间隔
      fiveMinutesFlag: true, //五分钟消息显示与否
      sourceUuid: "", //微信登陆id
      targetUserUuid: "",
      maskWrap: false,
      myInterval: null,
      contentTip: false,
      firstHeight: "",
      targetUserName: "", //记者昵称
      comeFlag: false, // 第一次进来页面标记
      delayTime: 0, //轮询时间
      interval: 8000, //轮询interval
      refreshList: [],
      moreMsg: false,
      toastOptions: {
        showTost: false,
        toastTxt: "",
      },
      showLoading: false,
      firstEnter: false,
      isTop: false,
      msgList: [],
      moreMsgAnimation: "",
      showSendBtn: false,
      timeout: null,
      showImageBtn: false,
      loadingText: "加载中...",
      showImgToast: false,
      imgToastTxt: "",
      sourceHeadImg: null
    };
  },
  components: {
    // nfItem,
    // nfUpdateTips
  },
  methods: {
    sendMessage() {
      let input = document.getElementById("input");
      this.message = input.value;
      if (!this.message) {
        this.contentTip = true;
        setTimeout(() => {
          this.contentTip = false;
        }, 2000);
        return;
      } else {
        // this.messageList.push(input.value)
        input.value = "";
        this.sendMessageAction()
      }
    },
    sendMessageAction(){
      let params = {
          entry: 0,
          content: this.message,
          targetUserUuid: this.targetUserUuid,
          sourceUuid: this.sourceUuid,
          // sourceUuid: 'a8a274cd-6af6-4ed8-b97d-40f4871ef079'
        };
        axios({
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          url: `${config.privateLetterUrl}ucapi/chat/add`,
          params,
        }).then((res) => {
          //输入框回到最初高度
          document.getElementById("input").style.height =
            this.firstHeight + "px";
          let sendCreatime = this.chatTimeFormat(res.data.data);
          let obj = {
            sourceUuid: res.data.data.sourceUuid,
            content: res.data.data.content,
            targetUserUuid: res.data.data.targetUserUuid,
            sourceHeadImg: res.data.data.sourceHeadImg,
            createTime: res.data.data.createTime,
            messageTime: sendCreatime,
            type: 31,
            extMsgObj: {}
          };
          this.messageList.push(obj);
          this.messageList = this.contrastData(this.messageList);
          this.$nextTick(() => {
            document.querySelector("#message-content").scrollTo(0, 9999999);
            if (!this.comeFlag) {
              this.maskWrap = true;
              this.comeFlag = true;
            }
          });
          this.showSendBtn = false;
        });
    },
    historyData() {
      this.showLoading = true;
      const currentTime = this.getNowFormatDate();
      let params = {
        entry: 0,
        groupType: "1",
        targetUserUuid: this.targetUserUuid,
        sourceUuid: this.sourceUuid,
        // sourceUuid:'a8a274cd-6af6-4ed8-b97d-40f4871ef079'
      };
      axios({
        method: "get",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `${config.privateLetterUrl}ucapi/chat/msgList/${currentTime}/${this.pageNum}/20`,
        params,
      }).then((res) => {
        let newArr = [];
        if (res.data.data.msgList.length == 0) {
          this.msgList = [];
          this.moreMsg = false;
          this.moreMsgAnimation = "moreMsgLeave";
          this.showLoading = false;

          if (!this.firstEnter) {
            this.toastOptions.showTost = true;
            this.toastOptions.toastTxt = "已加载全部私信消息";
          }
        }
        res.data.data.msgList.forEach((item) => {
          this.msgList = res.data.data.messageList;
          let itemCreateTime = this.chatTimeFormat(item);
          let obj = {
            sourceUuid: item.sourceUuid,
            content: item.content,
            targetUserUuid: item.targetUserUuid,
            sourceHeadImg: item.sourceHeadImg,
            messageTime: itemCreateTime,
            createTime: item.createTime,
            fiveMinutesFlag: item.fiveFlag,
            type: item.type,
            extMsgObj: item.extMsgObj || {}
          };
          newArr.push(obj);
          if (item.sourceUuid == this.sourceUuid && !this.sourceHeadImg) {
            this.sourceHeadImg = item.sourceHeadImg
          }
        });
        this.messageList = newArr.concat(this.messageList);
        this.messageList = this.contrastData(this.messageList);
        if (this.firstEnter) {
          this.$nextTick(() => {
            document.querySelector("#message-content").scrollTo(0, 9999);
            this.firstEnter = false;
          });
        }

        this.showLoading = false;
      });
    },
    //刷新
    refresh() {
      const currentTime = this.getNowFormatDate();
      let params = {
        entry: 0,
        sourceUuid: this.sourceUuid,
        // sourceUuid: "a8a274cd-6af6-4ed8-b97d-40f4871ef079",
        targetUserUuid: this.targetUserUuid,
      };
      axios({
        method: "get",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `${config.privateLetterUrl}ucapi/chat/target/${currentTime}`,
        params,
      }).then((res) => {
        this.delayTime = res.data.data.delayTime;
        this.interval = res.data.data.interval;
        if (res.data.data.msgList.length == 0) {
          return;
        } else {
          res.data.data.msgList.map((item) => {
            let sendCreatime = this.chatTimeFormat(item);
            let obj = {
              sourceUuid: item.sourceUuid,
              content: item.content,
              targetUserUuid: item.targetUserUuid,
              sourceHeadImg: item.sourceHeadImg,
              createTime: item.createTime,
              messageTime: sendCreatime,
            };
            this.messageList.push(obj);
            this.messageList = this.contrastData(this.messageList);
          });
          this.$nextTick(() => {
            document.querySelector("#message-content").scrollTo(0, 9999);
          });
        }
      });
    },
    //轮询
    roundRobin() {
      let robinTime = this.delayTime + this.interval;
      this.myInterval = window.setInterval(() => {
        setTimeout(() => {
          this.refresh(); //调用接口的方法
        }, 1);
      }, robinTime);
    },
    getNowFormatDate() {
      var date = new Date();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      var currentdate = `${date.getFullYear()}${month}${strDate}${hours}${minutes}${seconds}`;
      return currentdate;
    },
    continueLetter() {
      this.maskWrap = false;
    },
    //open
    open() {
      let reporterParams = {
        reporterUuid: this.targetUserUuid, //记者Uuid,
        weChatUuid: this.sourceUuid, //当前微信用户的uuid,
        reporterNickName: this.targetUserName,
        //记者昵称
      };

      window.OpenApp(
        {
          shareType: "reporterMessage",
          reporterMessage: reporterParams,
          needClipboard: false,
          address: window.location.href,
          title: '前往"' + this.targetUserName + '"作品集主页',
          openAppBigDataInfo: {
            origin: 7,
            sourceTag: 19,
            clickPosition: 36,
            itemId: this.targetUserUuid,
            weMediaId: this.targetUserUuid,
            url: window.location.href,
          },
        },
        process.env.VUE_APP_RUN_ENV
      );
    },
    close() {
      this.maskWrap = false;
    },
    //前往查看
    goToSee() {
      this.open();
    },
    handleInput(e) {
      e.target.style.height = "auto";
      e.target.style.height = e.target.scrollHeight + "px";

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.timeout = null;
        let input = document.getElementById("input");
        if(input.value){
          this.showSendBtn = true;
        } else {
          this.showSendBtn = false;
        }
      }, 100)
    },
    inputCilick() {
      // document.getElementById("input").scrollIntoView();
    },
    handleFocus() {
      let input = document.getElementById("input");
      if(input.value){
        this.showSendBtn = true;
      }
      setTimeout(() => {
        window.scrollTo(0, 9999999);
      }, 200);
    },
    handleBlur() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 200);
    },
    //点击刷新更多数据
    refreshMore() {
      this.pageNum = this.pageNum + 1;
      this.historyData();
    },
    //聊天时间格式化
    chatTimeFormat(item) {
      item.createTime = item.createTime.replace("-", "/").replace("-", "/");
      let currentTimeStamp =
        new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1; //当天23:59:59点时间戳\
      // let currentTimeStamp =new Date(new Date(new Date().toLocaleDateString()).getTime());
      let oneDay = 24 * 60 * 60;
      let twoDay = 24 * 60 * 60 * 2;
      let fiveDay = 24 * 60 * 60 * 5;
      let sixDay = 24 * 60 * 60 * 6;
      let itemCreateTime = "";
      let itemTimeTamp = Date.parse(item.createTime);
      let countDayStamp = (currentTimeStamp - itemTimeTamp) / 1000;
      if (countDayStamp < oneDay) {
        itemCreateTime = `${dayjs(item.createTime).format("HH:mm")}`;
        return itemCreateTime;
      }

      if (oneDay < countDayStamp && countDayStamp < twoDay) {
        itemCreateTime = `昨天 ${dayjs(item.createTime).format("HH:mm")}`;
        return itemCreateTime;
      }
      if (twoDay < countDayStamp && countDayStamp < fiveDay) {
        let weekDay = dayjs(item.createTime).day();
        let weekText = "";
        if (weekDay == 0) {
          weekText = "星期天";
        }
        if (weekDay == 1) {
          weekText = "星期一";
        }
        if (weekDay == 2) {
          weekText = "星期二";
        }
        if (weekDay == 3) {
          weekText = "星期三";
        }
        if (weekDay == 4) {
          weekText = "星期四";
        }
        if (weekDay == 5) {
          weekText = "星期五";
        }
        if (weekDay == 6) {
          weekText = "星期六";
        }
        itemCreateTime = `
            ${weekText} ${dayjs(item.createTime).format("HH:mm")}`;
        return itemCreateTime;
      }
      if (countDayStamp > sixDay) {
        let time = dayjs(item.createTime).format("YYYY/MM/DD HH:mm");
        itemCreateTime = time.replace("/", "-").replace("/", "-");

        return itemCreateTime;
      }
    },
    //数据下一条和上一条数据对比
    contrastData(data) {
      const newData = data.map((item, index) => {
        if (index == 0) {
          return {
            fiveFlag: true,
            ...item,
          };
        }
        return {
          fiveFlag:
            (Date.parse(data[index].createTime) -
              Date.parse(data[index - 1].createTime)) /
              1000 >
            300,
          ...item,
        };
      });
      return newData;
    },
    scrollBottomOrTop() {
      const ele = document.querySelector("#message-content");
      ele.onscroll = _.debounce(() => {
        scrollEvt();
      }, 50);
      const scrollEvt = () => {
        const isTop = ele.scrollTop <= 10;
        if (this.msgList && this.msgList.length == 0) {
          this.moreMsgAnimation = "moreMsgLeave";
          // this.moreMsg = false;
        } else {
          if (isTop) {
            this.moreMsgAnimation = "moreMsgEnter";
            this.moreMsg = true;
          } else {
            this.moreMsgAnimation = "moreMsgLeave";
            this.moreMsg = false;
          }
        }
      };
    },
    handleShowImageBtn(boolean){
      this.showImageBtn = boolean
    },
    chooseFileAction(event){
      const file = event.target.files[0]; // 获取选择的文件
      if (file && file.type.match('image.*')) { // 确保文件是图片类型
        // 回显图片
        const reader = new FileReader(); // 创建FileReader对象
        reader.onload = (e) => {
          // window.console.log(e.target.result);
          let obj = {
            sourceUuid: this.sourceUuid,
            content: '',
            targetUserUuid: this.targetUserUuid,
            sourceHeadImg: this.sourceHeadImg,
            createTime: dayjs().format("HH:mm"),
            messageTime: dayjs().format("HH:mm"),
            type: 32,
            extMsgObj: {
              imageUrl: e.target.result
            },
            loadingFlag: true,
            failFlag: false
          };
          this.messageList.push(obj);
          this.messageList = this.contrastData(this.messageList);
        };
        reader.readAsDataURL(file); // 读取文件内容并转换为DataURL

        // 上传图片
        const formData = new FormData();
        formData.append('file', file);
        axios.post(`${config.privateLetterUrl}ucapi/chat/uploadImage/${this.sourceUuid}/${this.targetUserUuid}/0`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {
          this.messageList.forEach((item) => {
            if(item.loadingFlag){
              item.loadingFlag = false;
              item.failFlag = false;
            }
          })
          this.$nextTick(() => {
            document.querySelector("#message-content").scrollTo(0, 9999999);
            if (!this.comeFlag) {
              this.maskWrap = true;
              this.comeFlag = true;
            }
          });
        })
        .catch((error) => {
          this.showImgToast = true;
          this.imgToastTxt = '图片上传失败';
          window.console.error(error)
          this.messageList.forEach((item) => {
            if(item.loadingFlag){
              item.loadingFlag = false;
              item.failFlag = true;
            }
          })
        });
      } else {
        this.showImgToast = true;
        this.imgToastTxt = '请选择一个图片文件';
      }
    },
    handleSelectFile(){
      let input = document.createElement("input")
      const isAndroid = navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("Adr") > -1
      // input存在multiple时安卓手机进入相册无法触发onchange
      if (!isAndroid) {
        input.setAttribute("multiple", this.multiple ? "multiple" : "false")
      }
      input.setAttribute("accept", this.accept)
      input.setAttribute("type", "file")
      input.style.position = "absolute"
      input.style.top = "-5000px"
      input.style.left = "-5000px"
      input.style.opacity = 0
      document.body.appendChild(input)
      const changeCb = e => {
        this.chooseFileAction(e)
        input.removeEventListener("change", changeCb)
        document.body.removeChild(input)
        input = null
      }
      input.addEventListener("change", changeCb)
      input.click()

      
    }
  },
  computed: {},
  destroyed() {
    clearInterval(this.myInterval);
  },
  mounted() {
    this.roundRobin();
    this.firstHeight = document.getElementById("input").scrollHeight;
    this.scrollBottomOrTop();
    window.onresize = () => {
      document.querySelector("#message-content").scrollTo(0, 9999);
    };
  },
  async created() {
    this.targetUserName = this.$route.query.reporterName; //当前记者昵称
    this.targetUserUuid = this.$route.query.targetUserUuid; //当前记者uuid

    this.sourceUuid = localStorage.getItem("wxUserUuid");
    // this.sourceUuid = "630ddac2-c30d-471f-897e-7020b79023aa";
    //  this.sourceUuid = "a8a274cd-6af6-4ed8-b97d-40f4871ef070";
    // this.targetUserUuid = "0d58f52a-cd5d-420e-9a66-3f30eb23548e";
    document.title = this.targetUserName;
    this.historyData();
    this.firstEnter = true;
  },
};
</script>

<style lang="scss" scoped>
.private-letter-page {
  position: relative;
  height: 100%;
  width: 100%;
  background: #f7f7f7;
  .private-letter {
    // width:100%;
    // height:100%;
    .tip {
      position: absolute;
      top: 0;
      background: #ffe7e7;
      line-height: 0.8rem;
      height: 0.8rem;
      padding-left: 0.3rem;
      padding-right: 0.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      z-index: 0;
      p {
        font-size: 0.28rem;
        color: #666666;
      }
      button {
        height: 0.52rem;
        line-height: 0.52rem;
        padding: 0 0.2rem;
        font-size: 0.28rem;
        color: #f64e45;
        border: 1px solid #f64e45;
        border-radius: 0.08rem;
        line-height: 0;
      }
    }
    // textarea{
    //   resize: none;
    // }
    .redOpen {
      width: 2.8rem;
      height: 0.72rem;
      font-size: 0.28rem;
      color: #ffffff;
      position: absolute;
      background: #f64e45;
      border-radius: 2rem 0 0 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      right: 0;
      bottom: 1.48rem;
    }
    .more {
      position: absolute;
      top: 1%;
      right: 50%;
      transform: translateX(50%);
      z-index: 2;
      // background: #fff;
      // box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.06);
      border-radius: 0.32rem;
      padding: 0.12rem 0.3rem;
      font-size: 0.28rem;
      color: #389bee;
      img {
        width: 14px;
        height: 13px;
        vertical-align: middle;
        margin-right: 0.1rem;
      }
    }
    .message-content {
      position: absolute;
      top: 0;
      width: 100%;
      height: calc(100% - 0.8rem);
      padding-bottom: 0.8rem;
      overflow: scroll;
      padding: 0.85rem 0.3rem 0.8rem;
      -webkit-overflow-scrolling: touch;
      .message-item-right {
        &:last-child {
          margin-bottom: 3rem;
        }
        .time {
          text-align: center;
          margin-bottom: 0.4rem;
          span {
            background: #cccccc;
            border-radius: 0.04rem;
            display: inline-block;
            padding: 0.1rem 0.1rem;
            color: #fff;
            font-size: 0.24rem;
            line-height: 1;
          }
        }
        .right-inner {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 0.3rem;
          .content {
            padding: 0.2rem 0.18rem 0.2rem 0.18rem;
            background: #cae4ff;
            border-radius: 0.08rem;
            max-width: 5rem;
            margin-right: 0.12rem;
            position: relative;
            font-size: 0.32rem;
            line-height: 1.3;
            color: #333;
            word-break: break-all;
            .arrow {
              width: 0.12rem;
              height: 0.36rem;
              position: absolute;
              right: -0.12rem;
            }
          }
          .img {
            width: 0.8rem;
            height: 0.8rem;
            margin-left: 0.12rem;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .icon-fail,.icon-uploading{
            position: absolute;
            top: 50%;
            left: -0.8rem;
            transform: translate(0%, -50%);
            width: 0.6rem;
            height: 0.6rem;  
          }
          .icon-fail{
            background: url("../../assets/icon_warning.jpg") no-repeat center center;
            background-size: cover;   
          }
          .icon-uploading{
            background: url("../../components/base/loading/images/loading.gif") no-repeat center center;
            background-size: cover;   
          }
        }
      }
      .message-item-left {
        .time {
          text-align: center;
          margin-bottom: 0.4rem;
          span {
            background: #cccccc;
            border-radius: 0.04rem;
            display: inline-block;
            padding: 0.1rem 0.1rem;
            color: #fff;
            font-size: 0.24rem;
            line-height: 1;
          }
        }
        .left-inner {
          display: flex;
          margin-bottom: 0.3rem;
          .content {
            padding: 0.2rem 0.18rem 0.2rem 0.18rem;
            background: #fff;
            border-radius: 0.08rem;
            max-width: 5rem;
            // margin: 0 0.12rem 0.3rem;
            position: relative;
            font-size: 0.32rem;
            line-height: 1.3;
            color: #333;
            margin-left: 0.12rem;
            .arrow {
              width: 0.12rem;
              height: 0.36rem;
              position: absolute;
              left: -0.12rem;
            }
          }
          .img {
            width: 0.8rem;
            height: 0.8rem;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
        }
      }
      .content-img{
        img{
          width: 100%;
          height: auto;
        }
      }
    }
    .send-message {
      position: absolute;
      bottom: 0rem;
      width: 100%;
      background: #f7f7f7;
      // height: 0.8rem;
      display: flex;
      flex-direction: column;
      width: 100%;
      border: 0.5px solid #dddddd;
      padding: 0.1rem 0 0.1rem;
      .text-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.3rem;
        margin-bottom: 0.13rem;
      }
      textarea {
        // height: 0.7rem;
        border-radius: 2rem;
        border: 0.5px solid #dddddd;
        border-radius: 0.36rem;
        background: #fff;
        width: 87%;
        padding: 0.12rem 0.2rem;
        color: #333;
        font-size: 0.32rem;
        outline: none;
        max-height: 1.7rem;
        -webkit-appearance: none;
        overflow-y: scroll;
      }
      .sendText {
        font-size: 0.32rem;
        color: #389bee;
        cursor: pointer;
      }
      .icon-plus{
        width: 0.6rem;
        height: 0.6rem;
        background: url("../../assets/chat_icon_add.png") no-repeat center center;
        background-size: cover;
        margin-left: 0.2rem;
      }
      .image-box{
        padding: 15px 0 0 18px;
        display: flex;
        border-top: 0.5px solid #ddd;
        .upload-item{
          width: 1.2rem;
          position: relative;
          .icon-upload{
            display: block;
            width: 1.2rem;
            line-height: 0.64rem;
            font-size: 0.24rem;
            text-align: center;
            i{
              display: block;
              width: 1.2rem;
              height: 1.2rem;
              background: url("../../assets/chat_icon_photo.png") no-repeat center center;
              background-size: cover;
            }
          }
          .image-input{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: transparent;
            opacity: 0;
            z-index: 100;
          }
        }
      }
    }
  }
  .maskWrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 1000;
    .innerBox {
      width: 80%;
      // height: 4.5rem;
      background: #ffffff;
      border-radius: 0.2rem;
      position: absolute;
      top: 50%;
      margin-top: -2rem;
      right: 50%;
      margin-right: -40%;
      display: flex;
      flex-direction: column;
      img {
        width: 0.28rem;
        height: 0.28rem;
        position: absolute;
        right: 0.3rem;
        top: 0.3rem;
      }
      .content {
        padding: 0 0.6rem;
        margin-top: 0.6rem;
        .title {
          font-size: 0.36rem;
          color: #333333;
          font-weight: bold;
          line-height: 1;
          margin-bottom: 0.3rem;
          text-align: center;
        }
        .check {
          font-size: 0.3rem;
          color: #666666;
        }
        .login {
          font-size: 0.3rem;
          color: #f64e45;
        }
      }

      .bottom-button {
        display: flex;
        margin: 0.4rem 0.4rem 0.6rem 0;
        .btn {
          padding: 0.22rem 0;
          border: 1px solid #999999;
          border-radius: 0.1rem;
          font-size: 0.32rem;
          color: #999999;
          line-height: 1;
          width: 2.44rem;
          display: flex;
          justify-content: center;
        }
        .red {
          background: #f64e45;
          color: #fff;
          margin-left: 0.32rem;
          border: none;
          padding-top: -0.01rem;
        }
      }
    }
  }
  .contentTip {
    opacity: 0.7;
    background: #000000;
    border-radius: 0.01rem;
    // width: 2.7rem;
    padding: 0.3rem 0.24rem;
    color: #fff;
    font-size: 0.3rem;
    border-radius: 0.1rem;
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
  }
  #moreMsgEnter {
    animation: mymove 0.3s;
    -webkit-animation: mymove 0.3s;
  }
  @keyframes mymove {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  #moreMsgLeave {
    animation: myleave 0.3s ease 0 1 normal;
    -webkit-animation: myleave 0.3s ease 0 1 normal;
  }
  @keyframes myleave {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
}
</style>
